/**
 * Google Analytics 4 utility
 * Measurement ID: G-VDJE1KVVEN
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const gtag: (...args: any[]) => void =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  (window as any).gtag || ((..._args: any[]) => {});

/** Track a page view (called automatically by usePageTracking) */
export const trackPageView = (path: string, title?: string) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
};

/** Track a custom event */
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};
